import { render, staticRenderFns } from "./slaSetting.vue?vue&type=template&id=68385ebe&scoped=true"
import script from "./slaSetting.vue?vue&type=script&lang=js"
export * from "./slaSetting.vue?vue&type=script&lang=js"
import style0 from "./slaSetting.vue?vue&type=style&index=0&id=68385ebe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68385ebe",
  null
  
)

export default component.exports